import { render, staticRenderFns } from "./navbarBox.vue?vue&type=template&id=fffc9450"
import script from "./navbarBox.vue?vue&type=script&lang=js"
export * from "./navbarBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports